<template>
  <v-layout 
    v-if="!isFinish && isLive"
    :reverse="reverse"
    row
    no-wrap>
    <!-- Local Event -->
    <v-flex 
      xs4
      d-flex >
      <v-card
        v-if="isLive && lastEvent && lastEvent.team==='l'"
        :color="lastEvent.color" 
        class="blink_me"
        dark>
        <span v-if="lastEvent.player && !extraPlayers.includes(lastEvent.player.num)">#{{ lastEvent.player.num }}</span>
        {{ $t(`sport.controls.${lastEvent.code}.description`) }}
      </v-card>
    </v-flex>
    <!-- Online -->
    <v-flex 
      v-if="isLive" 
      d-flex
      xs4>
      <v-card
        color="blue-grey" 
        class="blink_me"
        dark>
        {{ $t('page.match.online') }}
      </v-card>
    </v-flex>
    <!-- Visitor Event -->
    <v-flex 
      xs4
      d-flex >
      <v-card
        v-if="isLive && lastEvent && lastEvent.team==='v'"
        :color="lastEvent.color" 
        class="blink_me"
        dark>
        <span v-if="lastEvent.player && !extraPlayers.includes(lastEvent.player.num)">#{{ lastEvent.player.num }}</span>
        {{ $t(`sport.controls.${lastEvent.code}.description`) }}
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
// const debug = require('debug')('OD::BoardStatusRow')

export default {
  name: 'BoardStatusRow',
  components: {},
  props: {
    isLive: {
      type: Boolean,
      required: true,
    },
    isFinish: {
      type: Boolean,
      required: true,
    },
    lastEvent: {
      type: Object,
      default: null,
    },
    extraPlayers: {
      type: Array,
      required: true,
    },
    reverse: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  beforeDestroy() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
</style>
